import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { serverError } from "../../../../components/modals/payments/register/registerPaymentModal";

/*
	Descuentos › Limpieza: el expediente de un caso en ventana, sin salir de la lista (Esteban, 2026-10-27). Todas las notas que
	escribieron personas (perfil, matrícula, solicitud, pagos, facturas) y el estado de cuenta del alumno en el plantel:
	mensualidades, productos, pagos y facturas. Solo lectura; para cobrar o corregir está Finanzas (se abre en otra pestaña).
*/

const http = HttpManager.getInstance();
const num = (n: number | null | undefined) => n === null || n === undefined ? "—" : (Math.round(Number(n) * 100) / 100).toLocaleString("es-MX", { maximumFractionDigits: 2 });
/** "2026-10-27" o "2026-10-27T14:30" → "27/10/2026" (con la hora si viene). */
export const fecha = (s: string | null | undefined, conHora = false) => {
	if (!s) return "";
	const [d, t] = s.split("T");
	const [y, m, dd] = d.split("-");
	if (!conHora || !t) return dd + "/" + m + "/" + y;
	const [h, mi] = t.split(":").map(Number);
	return dd + "/" + m + "/" + y + " " + ((h % 12) || 12) + ":" + String(mi).padStart(2, "0") + (h < 12 ? " am" : " pm");
};

export const ListaDeNotas: React.FC<{ notas: any[]; vacio?: string }> = ({ notas, vacio }) => (
	!notas.length ? <div className="wdTenue" style={{ fontSize: 13 }}>{vacio || "Nadie ha escrito notas."}</div> : (
		<div className="wdNotas">
			{notas.map((n: any, i: number) => (
				<div key={"n" + i} className="wdNotaFila">
					<div className="wdNotaDe"><span className="wdChip wdChipFilo">{n.source}{n.ref ? " " + n.ref : ""}</span>{fecha(n.at, true)}{n.by ? " · " + n.by : ""}</div>
					<div className="wdNotaTxt">{n.text}</div>
				</div>
			))}
		</div>
	)
);

type Pestana = "notas" | "mensualidades" | "pagos" | "facturas";

/** sinCurso: dentro de un grupo por matrícula el curso ya va en el título (en el teléfono la columna ocupaba 3 líneas por renglón). */
const TablaMensualidades: React.FC<{ filas: any[]; sym: string; sinCurso?: boolean }> = ({ filas, sym, sinCurso }) => (
	<div className="wdTablaCaja">
		<table className="wdTabla">
			<thead><tr>{sinCurso ? null : <th>Curso</th>}<th>Cargo</th><th>Vence</th><th>Precio Normal</th><th>A Cobrar</th><th>Pagado</th><th>Estado</th><th>Factura</th></tr></thead>
			<tbody>{filas.map((t: any) => (
				<tr key={"t" + t.id} className={t.thisEnrollment ? "" : "wdOtroCurso"}>
					{sinCurso ? null : <td>{t.course}</td>}<td>{t.title || t.type}</td><td>{fecha(t.dueDate)}</td><td>{sym}{num(t.list)}</td>
					<td className={t.price < t.list - 0.005 ? "wdConDescuento" : ""}>{sym}{num(t.price)}{t.price < t.list - 0.005 && t.list > 0 ? <span className="wdTenue"> (−{Math.round((1 - t.price / t.list) * 100)} %)</span> : null}</td>
					<td>{sym}{num(t.paid)}</td><td>{t.status}</td><td>{t.invoice || ""}</td>
				</tr>
			))}</tbody>
		</table>
	</div>
);

/*
	Las mensualidades por matrícula (Esteban, 2026-10-27, caso Luis Enrique SPS: 3 horarios = 39 renglones mezclados): la matrícula
	de la limpieza arriba, luego sus otros cursos y al final los horarios anteriores (cambios de horario) plegados, con su nombre,
	la fecha del cambio y lo que quedó debiendo ahí.
*/
const MensualidadesPorHorario: React.FC<{ tuitions: any[]; enrollments: any[]; sym: string }> = ({ tuitions, enrollments, sym }) => {
	const [abiertos, setAbiertos] = useState<Record<number, boolean>>({});
	const orden = [...enrollments].sort((a, b) => (Number(b.current) - Number(a.current)) || (Number(a.previous) - Number(b.previous)) || String(b.createdAt).localeCompare(String(a.createdAt)));
	return (
		<>
			{orden.map((m: any) => {
				const filas = tuitions.filter((t: any) => t.enrollmentId === m.id);
				if (!filas.length) return null;
				const anuladas = filas.filter((t: any) => t.statusId === 4).length;
				const debe = filas.filter((t: any) => t.statusId !== 4).reduce((s: number, t: any) => s + Math.max(0, t.price - t.paid), 0);
				const titulo = <><b>{m.courseName}</b> · {m.scheduleName}</>;
				if (!m.previous) {
					return (
						<div key={"m" + m.id}>
							<div className="wdSub">{titulo}{m.current ? <span className="wdChip wdChipAcento" style={{ marginLeft: 8 }}>Esta matrícula</span> : null}
								<span className="wdTenue" style={{ fontWeight: 400, fontSize: 13 }}> · desde {fecha(m.createdAt)}</span></div>
							<TablaMensualidades filas={filas} sym={sym} sinCurso />
						</div>
					);
				}
				const abierto = !!abiertos[m.id];
				return (
					<div key={"m" + m.id} className="wdHorarioAnterior">
						<button type="button" className="wdHorarioCab" aria-expanded={abierto} onClick={() => setAbiertos({ ...abiertos, [m.id]: !abierto })}>
							<span className="wdHorarioFlecha">{abierto ? "▾" : "▸"}</span>
							<span>
								<span className="wdChip wdChipFilo">Horario Anterior</span>{titulo}
								<span className="wdTenue"> · del {fecha(m.createdAt)} al {fecha(m.changedAt)}{m.nextSchedule ? ", cambió a " + m.nextSchedule : ""}</span>
								<span className="wdTenue"> · {filas.length} cargos{anuladas ? ", " + anuladas + " anulados" : ""}</span>
								{debe > 0.005 ? <span className="wdOro"> · Quedó debiendo {sym}{num(debe)}</span> : null}
							</span>
						</button>
						{abierto ? <TablaMensualidades filas={filas} sym={sym} sinCurso /> : null}
					</div>
				);
			})}
		</>
	);
};

const ExpedienteLimpieza: React.FC<{ campusId: number; cleanupId: number; nombre: string; studentId: number; onClose: () => void }> = ({ campusId, cleanupId, nombre, studentId, onClose }) => {
	const [data, setData] = useState<any>(null);
	const [error, setError] = useState<string | null>(null);
	const [tab, setTab] = useState<Pestana>("mensualidades");

	useEffect(() => {
		http.paymentService.cleanupFile(campusId, cleanupId).then((r: any) => setData(r.data)).catch((e: any) => setError(serverError(e)));
	}, [campusId, cleanupId]);
	useEffect(() => {
		const esc = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
		window.addEventListener("keydown", esc);
		return () => window.removeEventListener("keydown", esc);
	}, [onClose]);

	const sym = data?.currencySymbol || "";
	const conteo = (n: number) => n ? " (" + n + ")" : "";
	return (
		<div className="wdVentanaFondo" onClick={onClose}>
			<div className="wdVentana waDescuentos" role="dialog" aria-label={"Estado de cuenta de " + nombre} onClick={(e) => e.stopPropagation()}>
				<div className="wdVentanaCab">
					<div style={{ minWidth: 0 }}>
						<div className="wdVentanaTit">{nombre}</div>
						{data ? <div className="wdTenue" style={{ fontSize: 13 }}>{data.student.identityCode} · {data.enrollment.courseName}
							{data.enrollment.createdAt ? " · Matriculada el " + fecha(data.enrollment.createdAt) : ""}{data.enrollment.createdBy ? " por " + data.enrollment.createdBy : ""}</div> : null}
					</div>
					<div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
						<a className="wdLink" href={`/statement?alumno=${studentId}&plantel=${campusId}`} target="_blank" rel="noopener noreferrer">Abrir Finanzas en Otra Pestaña</a>
						<button type="button" className="wdBoton" onClick={onClose} aria-label="Cerrar">Cerrar</button>
					</div>
				</div>
				{error ? <div className="wdAviso">{error}</div> : !data ? <div className="loader" /> : (
					<>
						<div className="wdTabs">
							<button type="button" className={"wdTab" + (tab === "mensualidades" ? " wdTabOn" : "")} onClick={() => setTab("mensualidades")}>Mensualidades{conteo(data.tuitions.length)}</button>
							<button type="button" className={"wdTab" + (tab === "pagos" ? " wdTabOn" : "")} onClick={() => setTab("pagos")}>Pagos{conteo(data.payments.length)}</button>
							<button type="button" className={"wdTab" + (tab === "facturas" ? " wdTabOn" : "")} onClick={() => setTab("facturas")}>Facturas{conteo(data.invoices.length)}</button>
							<button type="button" className={"wdTab" + (tab === "notas" ? " wdTabOn" : "")} onClick={() => setTab("notas")}>Notas{conteo(data.notes.length)}</button>
						</div>
						<div className="wdVentanaCuerpo">
							{tab === "notas" ? <ListaDeNotas notas={data.notes} /> : null}
							{tab === "mensualidades" ? (
								<>
									{data.enrollments?.length ? <MensualidadesPorHorario tuitions={data.tuitions} enrollments={data.enrollments} sym={sym} />
										: <TablaMensualidades filas={data.tuitions} sym={sym} />}
									{data.articles.length ? (
										<>
											<div className="wdSub">Productos y Kits</div>
											<div className="wdTablaCaja">
												<table className="wdTabla">
													<thead><tr><th>Producto</th><th>Precio</th><th>Pagado</th><th>Estado</th><th>Factura</th></tr></thead>
													<tbody>{data.articles.map((a: any) => (
														<tr key={"a" + a.id}><td>{a.title}</td><td>{sym}{num(a.price)}</td><td>{sym}{num(a.paid)}</td><td>{a.status}</td><td>{a.invoice || ""}</td></tr>
													))}</tbody>
												</table>
											</div>
										</>
									) : null}
								</>
							) : null}
							{tab === "pagos" ? (
								!data.payments.length ? <div className="wdTenue">No hay pagos registrados en este plantel.</div> : (
									<div className="wdTablaCaja">
										<table className="wdTabla">
											<thead><tr><th>Fecha</th><th>Monto</th><th>Forma</th><th>Estado</th><th>Factura</th><th>Nota</th></tr></thead>
											<tbody>{data.payments.map((p: any) => (
												<tr key={"p" + p.id} className={p.statusId === 1 ? "" : "wdOtroCurso"}>
													<td>{fecha(p.date)}</td><td>{sym}{num(p.amount)}</td><td>{p.method}{p.reference ? " · " + p.reference : ""}</td><td>{p.status}</td>
													<td>{p.invoice || ""}</td><td className="wdCeldaNota">{p.notes || ""}</td>
												</tr>
											))}</tbody>
										</table>
									</div>
								)
							) : null}
							{tab === "facturas" ? (
								!data.invoices.length ? <div className="wdTenue">No hay facturas en este plantel.</div> : (
									<>
										<div className="wdTablaCaja">
											<table className="wdTabla">
												<thead><tr><th>Factura</th><th>Fecha</th><th>Total</th><th>Pagado</th><th>Estado</th></tr></thead>
												<tbody>{data.invoices.map((i: any) => (
													<tr key={"i" + i.id} className={i.statusId === 3 ? "wdOtroCurso" : ""}>
														<td>{i.number}</td><td>{fecha(i.date)}</td><td>{sym}{num(i.total)}</td><td>{sym}{num(i.paid)}</td><td>{i.status}</td>
													</tr>
												))}</tbody>
											</table>
										</div>
										<div className="wdSub">Notas de las Facturas</div>
										<ListaDeNotas notas={data.notes.filter((n: any) => n.source === "Factura")} vacio="Ninguna factura tiene notas." />
									</>
								)
							) : null}
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default ExpedienteLimpieza;
